var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7134 8.28594L8.28594 12.7134C7.71719 12.1447 7.36719 11.3659 7.36719 10.4997C7.36719 8.76719 8.76719 7.36719 10.4997 7.36719C11.3659 7.36719 12.1447 7.71719 12.7134 8.28594Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5929 5.04867C14.0616 3.89367 12.3116 3.26367 10.5004 3.26367C7.4116 3.26367 4.53285 5.08367 2.5291 8.23367C1.7416 9.46742 1.7416 11.5412 2.5291 12.7749C3.22035 13.8599 4.02535 14.7962 4.90035 15.5487",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36719 17.0895C8.36469 17.5095 9.42344 17.737 10.4997 17.737C13.5884 17.737 16.4672 15.917 18.4709 12.767C19.2584 11.5332 19.2584 9.45945 18.4709 8.2257C18.1822 7.7707 17.8672 7.34195 17.5434 6.93945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.571 11.1133C13.3435 12.347 12.3373 13.3533 11.1035 13.5808",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28625 12.7129L1.75 19.2491",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2501 1.75L12.7139 8.28625",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.b4e8c00aaad97f75b91fd2c19a14b62f.svg";
export { ForwardRef as ReactComponent };